export const HOME_TITLES = [
  "Crafty Crofts",
  "Mission Control",
  "Dogtails Hotel",
  "Norabot 9000",
  "FamilyOS",
  "Home Base",
  "Famizon Prime",
  "The Familorian",
  "Hearth Vader",
  "MineCroft",
  "Homewarts",
  "Dumblechores",
] as const;

export type HomeTitle = (typeof HOME_TITLES)[number];

export function selectHomeTitle(random: () => number = Math.random): HomeTitle {
  return HOME_TITLES[Math.floor(random() * HOME_TITLES.length)]!;
}
